import React, { useEffect, useState } from "react";
import Layout from "../component/Layout/Layout";
import { Link, useLocation, useParams } from "react-router-dom";
import { useProductList } from "../hooks/useAllCategoryData";
import { useInView } from "react-intersection-observer";
import ProductListShimmer from "./ProductListShimmer";
import Breadcrumb from "./Breadcrumbs";
import ProductCard from "./ProductCard";
import FilterBar from "./FilterBar";
import {capitalizeFirstLetter } from "../Helper";

const ProductList = () => {
  const { categorySlug, subCategorySlug } = useParams();
  const location = useLocation();
  const segment = location.pathname.split('/');
  const catName = segment[segment.length-1].replaceAll('-', ' ');

  const searchParams = new URLSearchParams(location.search);
  const searchPro = searchParams.get("category_product");
  const searchCol = searchParams.get("colors");
  const searchShip = searchParams.get("shipping");
  const searchPrice = searchParams.get("priceRange");
  const searchOrderBy = searchParams.get("orderBy");
  const [selectedPrice, setSelectedPrice] = useState("Default");
  const [selectedValuePrice, setSelectedValuePrice] = useState("default");
  const [pageCount, setPageCount] = useState(0);
  
  const { ref, inView } = useInView();
  const LIMIT = 16;

  const {
    data: product,
    isSuccess,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isLoading: loading,
  } = useProductList(
    subCategorySlug ? subCategorySlug : categorySlug,
    searchPro,
    searchCol,
    searchShip,
    searchPrice,
    searchOrderBy,
    LIMIT
  );



  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, hasNextPage, isFetchingNextPage]);

  const [productFilter, setProductFilter] = useState(false);

  const showFilter = () => {
    setProductFilter(!productFilter);
  };

  //console.log(product)
  //console.log('TOTAL', product?.pages[0][0]?.tot);
  const contentProductList =
    isSuccess && product?.pages!=='' &&
    product?.pages?.map((page) =>
      page.map((pro, i) => {
        if (page.length === i + 1) {
          return <ProductCard ref={ref} key={pro.id} product={pro} />;
        }
        return <ProductCard key={pro.id} product={pro} />;
      })
    );

  const notfound = (
    
    <div className="product-notfound">
      <div>
        <h2>We are Sorry!</h2>
        <p>We couldn’t find anything matching your search criteria.</p>
        <p>Please try resetting the filters again</p>
      </div>
    </div>
  );

  const [productsort, setProductsort] = useState(false);

  const productsortClick = () => {
    setProductsort(!productsort);
  };


  const handleCheck = (e) => {
    setSelectedPrice(e.currentTarget.dataset.tag);
    setSelectedValuePrice(e.currentTarget.dataset.id); 
    setProductsort(0);
    //console.log(productsort)
  }
 
 
//console.log(contentProductList)

  return (
    <Layout title={`${capitalizeFirstLetter(catName)} | Chaashni Couture`} description="Chaashni Couture: Description">
      <div className="site-content-wrap product-list">
        <div className="container">
          <div className="row">
            <div className="col-md-12 breadcrumb">
              <ul>
                <Breadcrumb staticWord="category" />
              </ul>
            </div>
            <div className="product-filter-btn">
              {
                <Link onClick={showFilter}>
                  <i className="fa fa-filter" aria-hidden="true"></i> Filter
                </Link>
              }
            </div>
            <div
              className={
                productFilter
                  ? "row productlist-wrap active-filter"
                  : "row productlist-wrap"
              }
            >
              <div className="product-overlay" onClick={showFilter}></div>
              <div className="col-md-3 product-filter">
                <FilterBar product={product} price={selectedValuePrice} setClearDrop={setSelectedPrice}/>
              </div>

              <div className="col-md-9 product-right">
                <div className="row sortby-filter">
                    <div className="sortby-count">Showing total <strong> {product?.pages[0][0]?.tot?product?.pages[0][0]?.tot:0}</strong> results</div>
                    <div className="sortby-price" >
                      <div className="sortby-text" onClick={productsortClick}>Sort by : <strong>{selectedPrice}</strong> <i className="fa-solid fa-angle-down"></i></div>
                      <ul className={`sort-list ${productsort ? 'active' : ''}`}>
                        <li className={selectedPrice === 'Default' ? "active" : ""} onClick={handleCheck} data-tag="Default" data-id="default"><label className="sort-label "><input type="radio" value="default" /> Default</label></li>
                        <li className={selectedPrice === 'Price: High to Low' ? "active" : ""} onClick={handleCheck} data-tag="Price: High to Low" data-id="price_desc"><label className="sort-label "><input type="radio" value="price_desc" />Price: High to Low</label></li>
                        <li className={selectedPrice === 'Price: Low to High' ? "active" : ""} onClick={handleCheck} data-tag="Price: Low to High" data-id="price_asc"><label className="sort-label "><input type="radio" value="price_asc" /> Price: Low to High</label></li>
                      </ul>
                    </div>
                </div>
                <div className="row product-list-wrap">
                  {loading ? (
                    Array.from({ length: 6 }, (_, index) => (
                      <ProductListShimmer key={index} />
                    ))
                  ) : (
                    <>
                      {contentProductList[0]?.length > 0
                        ? contentProductList
                        : notfound}
                      {isFetchingNextPage && hasNextPage && (
                        <div className="loading-div">
                          <span>Loading...</span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProductList;
